import sessionReducer from "modules/login/redux/session.slice";
import partnersReducer from "modules/partners/redux/partners.slice";
import companiesReducer from "modules/companies/redux/companies.slice";
import usersReducer from "modules/users/redux/users.slice";
import subscriptionsReducer from "modules/subscriptions/redux/subscriptions.slice";
import salesPersonsReducer from "modules/sales-persons/redux/sales-persons.slice";
import approvalsReducer from "modules/approvals/redux/approvals.slice";
import consumerEngagementReducer from "modules/consumer-engagement/redux/consumer-engagement.slice";
import emailLogReducer from "modules/email-log/redux/email-log.slice";
import masterControlReducer from "modules/master-control/redux/master-control.slice";
import dataSummaryReducer from "modules/data-summary/redux/data-summary.slice";
import managementSnReducer from "modules/management-sn/redux/management-sn.slice";
import adminsReducer from "modules/admins/redux/admins.slice";
import dashboardReducer from "modules/dashboard/redux/dashboard.slice";

const rootReducer = {
  session: sessionReducer,
  partners: partnersReducer,
  companies: companiesReducer,
  users: usersReducer,
  subscriptions: subscriptionsReducer,
  salesPersons: salesPersonsReducer,
  approvals: approvalsReducer,
  consumerEngagement: consumerEngagementReducer,
  emailLog: emailLogReducer,
  masterControl: masterControlReducer,
  dataSummary: dataSummaryReducer,
  managementSn: managementSnReducer,
  admins: adminsReducer,
  dashboard: dashboardReducer,
};

export default rootReducer;
